import { IconographyTypes } from '@genial/icons';
import { Utils } from '@genial/utils';
import { ParamListBase, RouteProp } from '@react-navigation/native';
import React, { createContext, useState } from 'react';

export const AppMenuContext = createContext<AppMenuContextType>({
  isOpen: false,
  setIsOpen: () => {},
  items: [],
  setItems: () => {},
  currentRoute: undefined,
  setCurrentRoute: () => {},
});

export type AppMenuItem = {
  label: string;
  routeName: string;
  routeParams?: Record<string, any>;
  icon: {
    name: IconographyTypes.Option;
    size: Utils.IconTypes.SizeTokens;
  };
};

export interface AppMenuContextType {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  items: AppMenuItem[];
  setItems: (items: AppMenuItem[]) => void;
  currentRoute: RouteProp<ParamListBase> | undefined;
  setCurrentRoute: (route: RouteProp<ParamListBase>) => void;
}

export const AppMenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [items, setItems] = useState<AppMenuItem[]>([]);
  const [currentRoute, setCurrentRoute] = useState<RouteProp<ParamListBase> | undefined>(undefined);

  return (
    <AppMenuContext.Provider
      value={{ isOpen, setIsOpen, items, setItems, currentRoute, setCurrentRoute }}>
      {children}
    </AppMenuContext.Provider>
  );
};
